var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscribersTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000001856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.2986 21.6243H2.83413C1.67031 21.6243 0.844023 20.4903 1.20039 19.3824C2.14705 16.439 5.04843 14.3091 8.30647 14.3091C9.86068 14.3091 11.0598 14.6914 12.2446 15.5179M11.87 10.728C13.2036 9.31744 15.0923 8.43733 17.1867 8.43733C18.7409 8.43733 20.1818 8.922 21.3667 9.74845M15.8589 21.4631L13.4588 18.9337M22.8501 14.4904L15.8682 21.4723M4.8075 10.7655C4.8075 8.82273 6.38247 7.24778 8.32526 7.24778C10.268 7.24778 11.843 8.82273 11.843 10.7655C11.843 12.7083 10.268 14.2832 8.32526 14.2832C6.38247 14.2832 4.8075 12.7083 4.8075 10.7655ZM13.6877 4.8937C13.6877 2.95093 15.2627 1.37598 17.2054 1.37598C19.1482 1.37598 20.7232 2.95093 20.7232 4.8937C20.7232 6.83646 19.1482 8.41142 17.2054 8.41142C15.2627 8.41142 13.6877 6.83646 13.6877 4.8937Z",
    stroke: "#A175FF",
    strokeWidth: 2.00001,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribersTheme);
export default __webpack_public_path__ + "static/media/SubscribersTheme.cf3094e256d230710cbbefd80607d7a0.svg";
export { ForwardRef as ReactComponent };